import { render, staticRenderFns } from "./information-detail.vue?vue&type=template&id=1a03f2e4&scoped=true&"
import script from "./information-detail.vue?vue&type=script&lang=js&"
export * from "./information-detail.vue?vue&type=script&lang=js&"
import style0 from "./information-detail.vue?vue&type=style&index=0&id=1a03f2e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a03f2e4",
  null
  
)

export default component.exports